import { apiClient } from '../../api/client';
import type { DashboardExpenses, DashboardSummary, DashboardTrends } from '../../api/types';

/** `GET /dashboard/summary?companyId=` (task-8d-brief.md §1 / ruling R29). */
export async function fetchDashboardSummary(companyId: string): Promise<DashboardSummary> {
  const { data } = await apiClient.get<DashboardSummary>('/dashboard/summary', { params: { companyId } });
  return data;
}

/** `GET /dashboard/trends?companyId=` — year-over-year sales/collections
 * series and the VAT-threshold turnover for the dashboard chart widgets. */
export async function fetchDashboardTrends(companyId: string): Promise<DashboardTrends> {
  const { data } = await apiClient.get<DashboardTrends>('/dashboard/trends', { params: { companyId } });
  return data;
}

/** `GET /dashboard/expenses?companyId=` — cheltuieli pe categorii + estimarea
 * de profit/dividende. */
export async function fetchDashboardExpenses(companyId: string): Promise<DashboardExpenses> {
  const { data } = await apiClient.get<DashboardExpenses>('/dashboard/expenses', { params: { companyId } });
  return data;
}
